import PropTypes from 'prop-types';
import React from 'react';
import style from './ChaserRadioButton.module.scss';

const ChaserRadioButton = ({
  text = '',
  id = undefined,
  value = '',
  checked = false,
  disabled = false,
  name = '',
  required = false,
  onClick = () => {},
  onChange = () => {},
  ...rest
}) => {
  return (
    <label className={style.label}>
      <input
        id={id}
        type="radio"
        checked={checked}
        className={style.input}
        disabled={disabled}
        name={name}
        required={required}
        value={value}
        onClick={onClick}
        onChange={onChange}
        {...rest}
      />
      <span className={style.shape}>{checked && <span className={style.checkedIcon} />}</span>
      {text && <span className={style.text}>{text}</span>}
    </label>
  );
};

ChaserRadioButton.propTypes = {
  onChange: PropTypes.func,
  id: PropTypes.string,
  onClick: PropTypes.func,
  text: PropTypes.string,
  value: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  required: PropTypes.bool,
};

export default ChaserRadioButton;
